import React, { useContext, useEffect, useState } from "react";
import SetupRadio from "../SharedComponents/SetupRadio";
import SetupDropDown from "../SharedComponents/SetupDropdown";
import SubmitBtn from "../SharedComponents/SubmitBtn";
import SetupInput from "../SharedComponents/SetupInput";
import SetupContainer from "../SharedComponents/SetupContainer";
import SetupTittle from "../SharedComponents/SetupTittle";
import Box from "../SharedComponents/Box";
import axios from "axios";
import HistoryTable from "../SharedComponents/HistoryTable";
import SetupTextArea from "../SharedComponents/SetupTextArea";
import Swal from "sweetalert2";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";

const Pickup = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  useEffect(() => {
    axios
      .get(`${backendUrl}Pickup`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => console.log(err.message));
  }, [backendUrl, refetch]);

  // input fields handle.
  const initialValue = {
    id: 0,
    pickUpDescription: "",
    cost: "",
    isActive: "",
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
    branchId: "",
    branchName: "string",
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);

  const update = (data) => {
    setFormData({ ...formData, ...data });
  };
  const { handleDataReload } = useContext(contextProvider);
  const formHandle = (e) => {
    e.preventDefault();
    console.log({ ...formData });

    if (!willUpdate) {
      axios
        .post(`${backendUrl}Pickup`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 201) {
            Swal.fire({
              title: `Pickup Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) => console.log(err.message));
    }

    if (willUpdate) {
      console.log(formData);
      axios
        .put(`${backendUrl}Pickup/${formData.id}`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 204) {
            Swal.fire({
              title: `Pickup Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) => console.log(err.message));
    }
  };

  return (
    <div>
      <Box top>
        <SetupTittle text="Pickup" />
        <SetupContainer>
          <form className="" onSubmit={formHandle}>
            <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
              <SetupInput
                name="pickUpDescription"
                type="text"
                placeHolder="Pickup name"
                allTimeValue={formData.pickUpDescription}
                valueUpdate={(e) =>
                  update({ pickUpDescription: e.target.value })
                }
              />
              <SetupInput
                name="cost"
                type="number"
                placeHolder="Cost"
                allTimeValue={formData.cost}
                valueUpdate={(e) => update({ cost: parseInt(e.target.value) })}
              />
              <SetupDropDown // need to change
                dataOf="branch"
                allTimeValue={formData.branchId}
                valueUpdate={(e) =>
                  update({ branchId: parseInt(e.target.value) })
                }
                placeHolder="Branch"
                name="branchId"
              ></SetupDropDown>
              <SetupRadio
                name="isActive"
                placeHolder="Pickup status?"
                allTimeValue={formData.isActive}
                valueUpdate={(data) => update({ isActive: data })}
              />
            </div>

            <SubmitBtn text={willUpdate ? "Update" : "Create"} />
            <SubmitBtn
              onClick={() => {
                setWillUpdate(false);
                update(initialValue);
              }}
              styleClass={!willUpdate && "hidden"}
              text="Cancel"
            />
          </form>
        </SetupContainer>
      </Box>
      <Box>
        <SetupTittle text="History" />
        <SetupContainer>
          <HistoryTable
            editCallBack={(data) => {
              update(data);
              setWillUpdate(true);
            }}
            fetchedData={fetchedData}
            headers={["Pickup Name", "Cost", "Branch", "Status"]}
            row={["pickUpDescription", "cost", "branchName", "isActive"]}
            extraFields={["branchId"]}
          />
        </SetupContainer>
      </Box>
    </div>
  );
};

export default Pickup;
